import Mock from "../mock";

const database = {
  information: {
    name: "Paul Ritter",
    aboutMe1: "I'm a web developer and photographer.",
    aboutMe2: "Click around to find out more.",
    aboutMe3: "Like this website? I could build something like this for you!",
    aboutWeb:
      "I'm a web developer; I love building digital pathways for positive user experiences by creating accessible and engaging interfaces and content. I enjoy using analytics to track and predict trends in user behaviour, and recently I've been building with React and RESTful APIs.",
    aboutPhoto: "I'm also a photographer; some of my favourite scenes and subjects to capture are landscapes, wildlife and emotive portraits...oh, and my cats. Recently I've been having a lot of fun with aerial photography and videography.",
    aboutPhotography: "I love taking photographs; here are a few of my favourites!",
    age: 36,
    phone: "",
    nationality: "Canadian",
    language: "English",
    email: "",
    address: "",
    freelanceStatus: "Available",
    socialLinks: {
      facebook: "https://facebook.com/paulritterphotography",
      instagram: "https://instagram.com/paulritter",
      linkedin: "https://ca.linkedin.com/in/paulxritter",
      github: "https://github.com/dotslashpaul",
      twitter: "https://twitter.com/paulritter",
      pinterest: "https://pinterest.com/paulxritter",
      dev: "https://rittr.dev",
      website: "https://paulritter.ca",
      behance: "",      
      dribbble: "",      
    },
    brandImage: "/images/me.jpg",
    aboutImage: "/images/about.jpg",
    aboutImageLg: "/images/about-large.jpg",
    portfolioLinkPhoto: "https://paulritterphotography.ca",
    portfolioLinkDev: "https://rittr.dev",
  },
  services: [
    {
      title: "Web Development",
      icon: "code",
      details:
        "I can help you build a fast, engaging and accessible website that is easy to navigate and will look great on any device.",
    },
    {
      title: "UX/UI Design",
      icon: "brush-alt",
      details:
        "I can help you design something that will speak to and resonate with your audience, and build it to be accessible for everyone.",
    },
    {
      title: "Website Management",
      icon: "network",
      details:
        "I can help you manage, upgrade or secure your existing website, including WordPress, Drupal and even custom CMS platforms.",
    },
    {
      title: "QA/UX Auditing",
      icon: "list",
      details:
        "I can help you identify potential barriers for your customers and opportunities to improve the experience for your users.",
    },
    {
      title: "Web Hosting",
      icon: "database",
      details:
        "I can host your small-to-medium size website with 99.9% uptime and SSL encryption for a very reasonable fee.",
    },
    {
      title: "Analytics & Reporting",
      icon: "bar-chart",
      details:
        "I can add GA4/GTM to your website to track and report how people are finding you and engaging with your content.",
    },
  ],
  reviews: [
    {
      id: 1,
      content: "Paul's photography is beautiful, tranquil, and peaceful. The artistry in capturing these moments is amazing.",
      author: {
        name: "Judy B.",
        designation: "Client",
      },
    },
    {
      id: 2,
      content: "I am in awe of the beauty that Paul captures in his photography! Absolutely stunning work!",
      author: {
        name: "Lois F.",
        designation: "Client",
      },
    },
    {
      id: 3,
      content:
        "I would highly recommend Paul for any special occasions where you want to capture that special moment. His eye for detail is exceptional.",
      author: {
        name: "Randy K.",
        designation: "Client",
      },
    },
    {
      id: 4,
      content: "Amazingly beautiful pictures, captures the stillness of nature!",
      author: {
        name: "Susan D.",
        designation: "Client",
      },
    },
    {
      id: 5,
      content:
        "Paul's photos are just so beautiful and shines the light on how beautiful North Bay really is!",
      author: {
        name: "Sue M.",
        designation: "Client",
      },
    },
    {
      id: 6,
      content: "Paul lets you bring the most beautiful sunsets into your home.",
      author: {
        name: "Brigitte B.",
        designation: "Client",
      },
    },    
  ],
  skills: [
    {
      title: "HTML5",
      value: 95,
    },
    {
      title: "CSS3",
      value: 90,
    },
    {
      title: "JavaScript",
      value: 80,
    },
    {
      title: "PHP",
      value: 75,
    },
    {
      title: "TypeScript",
      value: 70,
    },
    {
      title: "Python",
      value: 65,
    },
    {
      title: "SQL",
      value: 70,
    },
    {
      title: "React",
      value: 65,
    },
    {
      title: "Bootstrap",
      value: 85,
    },    
    {
      title: "jQuery",
      value: 85,
    },    
    {
      title: "WordPress",
      value: 95,
    },
    {
      title: "Drupal",
      value: 90,
    },
    {
      title: "Power Automate",
      value: 70,
    },
    {
      title: "Photoshop",
      value: 85,
    },    
    {
      title: "InDesign",
      value: 70,
    },    
    {
      title: "Analytics & GTM",
      value: 90,
    },
    {
      title: "AODA",
      value: 95,
    },
    {
      title: "WCAG2",
      value: 90,
    },
  ],
  portfolios: [
    {
      id: 1,
      title: "North Bay Waterfront Marina",
      subtitle: "May 5, 2023",
      imageUrl: "/images/photos/thumbs/_MG_3101.jpg",
      largeImageUrl: ["/images/photos/_MG_3101.jpg"],
    },
    {
      id: 2,
      title: "Sgt. Pepper",
      subtitle: "July 5, 2023",
      imageUrl: "/images/photos/thumbs/_MG_4671.jpg",
      largeImageUrl: ["/images/photos/_MG_4671.jpg"],
    },
    {
      id: 3,
      title: "Nipissing University",
      subtitle: "September 21, 2023",
      imageUrl: "/images/photos/thumbs/_MG_6114s.jpg",
      largeImageUrl: ["/images/photos/_MG_6114s.jpg"],
    },
    {
      id: 4,
      title: "Gizmo",
      subtitle: "December 15, 2018",
      imageUrl: "/images/photos/thumbs/_MG_4981.jpg",
      largeImageUrl: ["/images/photos/_MG_4981.jpg"],
    },    
    {
      id: 5,
      title: "Chief Commanda II",
      subtitle: "September 21, 2023",
      imageUrl: "/images/photos/thumbs/DJI_0353c.jpg",
      largeImageUrl: ["/images/photos/DJI_0353c.jpg"],
    },
    {
      id: 6,
      title: "Phoebe",
      subtitle: "September 20, 2022",
      imageUrl: "/images/photos/thumbs/_MG_3159.jpg",
      largeImageUrl: ["/images/photos/_MG_3159.jpg"],
    },
    {
      id: 7,
      title: "Callander Bay",
      subtitle: "August 17, 2022",
      imageUrl: "/images/photos/thumbs/_MG_7312.jpg",
      largeImageUrl: ["/images/photos/_MG_7312.jpg"],
    },
    {
      id: 8,
      title: "Mischa",
      subtitle: "January 20, 2023",
      imageUrl: "/images/photos/thumbs/_MG_4952sc.jpg",
      largeImageUrl: ["/images/photos/_MG_4952sc.jpg"],
    },
    {
      id: 9,
      title: "Delaney Bay",
      subtitle: "May 28, 2017",
      imageUrl: "/images/photos/thumbs/IMG_3878.jpg",
      largeImageUrl: ["/images/photos/IMG_3878.jpg"],
    },
        {
      id: 10,
      title: "Sgt. Pepper",
      subtitle: "January 12, 2019",
      imageUrl: "/images/photos/thumbs/_MG_6631.jpg",
      largeImageUrl: ["/images/photos/_MG_6631.jpg"],
    },
    {
      id: 11,
      title: "Duchesnay Falls",
      subtitle: "May 20, 2024",
      imageUrl: "/images/photos/thumbs/DJI_20240520134719_0548_D.jpg",
      largeImageUrl: ["/images/photos/DJI_20240520134719_0548_D.jpg"],
    },
    {
      id: 12,
      title: "Mischa",
      subtitle: "January 7, 2023",
      imageUrl: "/images/photos/thumbs/_MG_2652.jpg",
      largeImageUrl: ["/images/photos/_MG_2652.jpg"],
    },
    {
      id: 13,
      title: "Chief Commanda II",
      subtitle: "September 15, 2023",
      imageUrl: "/images/photos/thumbs/_MG_9567.jpg",
      largeImageUrl: ["/images/photos/_MG_9567.jpg"],
    },
    {
      id: 14,
      title: "Sgt. Pepper",
      subtitle: "October 28, 2018",
      imageUrl: "/images/photos/thumbs/_MG_2605c.jpg",
      largeImageUrl: ["/images/photos/_MG_2605c.jpg"],
    },
    {
      id: 15,
      title: "Delaney Bay",
      subtitle: "September 7, 2019",
      imageUrl: "/images/photos/thumbs/_MG_3492s.jpg",
      largeImageUrl: ["/images/photos/_MG_3492s.jpg"],
    },
    {
      id: 16,
      title: "Gizmo",
      subtitle: "March 27, 2020",
      imageUrl: "/images/photos/thumbs/_MG_1241.jpg",
      largeImageUrl: ["/images/photos/_MG_1241.jpg"],
    },
    {
      id: 17,
      title: "Trout Lake",
      subtitle: "June 1, 2024",
      imageUrl: "/images/photos/thumbs/_MG_1946.jpg",
      largeImageUrl: ["/images/photos/_MG_1946.jpg"],
    },
    {
      id: 18,
      title: "Mischa",
      subtitle: "January 1, 2025",
      imageUrl: "/images/photos/thumbs/_MG_7263.jpg",
      largeImageUrl: ["/images/photos/_MG_7263.jpg"],
    },    
    {
      id: 19,
      title: "Trout Mills",
      subtitle: "July 17, 2024",
      imageUrl: "/images/photos/thumbs/_MG_1402.jpg",
      largeImageUrl: ["/images/photos/_MG_1402.jpg"],
    },
    {
      id: 20,
      title: "Mischa",
      subtitle: "October 13, 2023",
      imageUrl: "/images/photos/thumbs/_MG_0839.jpg",
      largeImageUrl: ["/images/photos/_MG_0839.jpg"],
    },
    { 
      id: 21,
      title: "Lake Nipissing",
      subtitle: "June 2, 2020",
      imageUrl: "/images/photos/thumbs/_MG_2899.jpg",
      largeImageUrl: ["/images/photos/_MG_2899.jpg"],
    },
    {
      id: 22,
      title: "Gizmo",
      subtitle: "March 19, 2020",
      imageUrl: "/images/photos/thumbs/_MG_0656.jpg",
      largeImageUrl: ["/images/photos/_MG_0656.jpg"],
    },
    {
      id: 23,
      title: "Temagami",
      subtitle: "October 5, 2019",
      imageUrl: "/images/photos/thumbs/DJI_0877.jpg",
      largeImageUrl: ["/images/photos/DJI_0877.jpg"],
    },
    {
      id: 24,
      title: "Mischa",
      subtitle: "October 28, 2024",
      imageUrl: "/images/photos/thumbs/_MG_2105.jpg",
      largeImageUrl: ["/images/photos/_MG_2105.jpg"],
    },
    {
      id: 25,
      title: "North Bay Waterfront Marina",
      subtitle: "May 23, 2023",
      imageUrl: "/images/photos/thumbs/DJI_0619s.jpg",
      largeImageUrl: ["/images/photos/DJI_0619s.jpg"],
    },
    {
      id: 26,
      title: "Gizmo and Sgt. Pepper",
      subtitle: "October 22, 2018",
      imageUrl: "/images/photos/thumbs/_MG_1786c.jpg",
      largeImageUrl: ["/images/photos/_MG_1786c.jpg"],
    },
    {
      id: 27,
      title: "Lake Nipissing",
      subtitle: "September 16, 2019",
      imageUrl: "/images/photos/thumbs/_MG_5229.jpg",
      largeImageUrl: ["/images/photos/_MG_5229.jpg"],
    },
    {
      id: 28,
      title: "Gizmo and Sgt. Pepper",
      subtitle: "January 20, 2018",
      imageUrl: "/images/photos/thumbs/IMG_5896.jpg",
      largeImageUrl: ["/images/photos/IMG_5896.jpg"],
    },
    {
      id: 29,
      title: "Duchesnay Falls",
      subtitle: "October 1, 2023",
      imageUrl: "/images/photos/thumbs/_MG_2450.jpg",
      largeImageUrl: ["/images/photos/_MG_2450.jpg"],
    },
    {
      id: 30,
      title: "Chipmunk",
      subtitle: "June 3, 2024",
      imageUrl: "/images/photos/thumbs/_MG_3097.jpg",
      largeImageUrl: ["/images/photos/_MG_3097.jpg"],
    },
    {
      id: 31,
      title: "King's Landing",
      subtitle: "June 22, 2023",
      imageUrl: "/images/photos/thumbs/_MG_1523.jpg",
      largeImageUrl: ["/images/photos/_MG_1523.jpg"],
    },
    {
      id: 32,
      title: "Joneszy",
      subtitle: "June 16, 2024",
      imageUrl: "/images/photos/thumbs/_MG_4994.jpg",
      largeImageUrl: ["/images/photos/_MG_4994.jpg"],
    },
    {
      id: 33,
      title: "Farquhar Lighthouse",
      subtitle: "August 14, 2024",
      imageUrl: "/images/photos/thumbs/_MG_5600.jpg",
      largeImageUrl: ["/images/photos/_MG_5600.jpg"],
    },
    {
      id: 34,
      title: "Sgt. Pepper",
      subtitle: "March 11, 2025",
      imageUrl: "/images/photos/thumbs/_MG_0028.jpg",
      largeImageUrl: ["/images/photos/_MG_0028.jpg"],
    },
    {
      id: 35,
      title: "The Motherhouse",
      subtitle: "January 22, 2023",
      imageUrl: "/images/photos/thumbs/_MG_5321.jpg",
      largeImageUrl: ["/images/photos/_MG_5321.jpg"],
    },
    {
      id: 36,
      title: "Waterfront Bandshell",
      subtitle: "July 31, 2023",
      imageUrl: "/images/photos/thumbs/_MG_4342s.jpg",
      largeImageUrl: ["/images/photos/_MG_4342s.jpg"],
    },
    {
      id: 37,
      title: "Lake Nipissing",
      subtitle: "September 16, 2019",
      imageUrl: "/images/photos/thumbs/_MG_5155.jpg",
      largeImageUrl: ["/images/photos/_MG_5155.jpg"],
    },
    {
      id: 38,
      title: "Sgt. Pepper",
      subtitle: "October 13, 2023",
      imageUrl: "/images/photos/thumbs/_MG_0204.jpg",
      largeImageUrl: ["/images/photos/_MG_0204.jpg"],
    },
    {
      id: 39,
      title: "Trout Mills",
      subtitle: "September 7, 2019",
      imageUrl: "/images/photos/thumbs/_MG_3458.jpg",
      largeImageUrl: ["/images/photos/_MG_3458.jpg"],
    },
    {
      id: 40,
      title: "Sgt. Pepper",
      subtitle: "May 17, 2018",
      imageUrl: "/images/photos/thumbs/_MG_1946_2.jpg",
      largeImageUrl: ["/images/photos/_MG_1946_2.jpg"],
    },
    {
      id: 41,
      title: "Duchesnay Falls",
      subtitle: "October 13, 2018",
      imageUrl: "/images/photos/thumbs/_MG_0358.jpg",
      largeImageUrl: ["/images/photos/_MG_0358.jpg"],
    },
    {
      id: 42,
      title: "Ice Follies",
      subtitle: "February 11, 2025",
      imageUrl: "/images/photos/thumbs/_MG_3748s.jpg",
      largeImageUrl: ["/images/photos/_MG_3748s.jpg"],
    },
    {
      id: 43,
      title: "Sunset Park",
      subtitle: "June 3, 2024",
      imageUrl: "/images/photos/thumbs/DJI_20240603201949_0043_D.jpg",
      largeImageUrl: ["/images/photos/DJI_20240603201949_0043_D.jpg"],
    },
    {
      id: 44,
      title: "Sgt. Pepper",
      subtitle: "September 18, 2024",
      imageUrl: "/images/photos/thumbs/_MG_4766.jpg",
      largeImageUrl: ["/images/photos/_MG_4766.jpg"],
    },
    {
      id: 45,
      title: "Lake Nipissing",
      subtitle: "September 18, 2024",
      imageUrl: "/images/photos/thumbs/_MG_5295.jpg",
      largeImageUrl: ["/images/photos/_MG_5295.jpg"],
    },
    {
      id: 46,
      title: "Gizmo",
      subtitle: "May 17, 2018",
      imageUrl: "/images/photos/thumbs/_MG_1839.jpg",
      largeImageUrl: ["/images/photos/_MG_1839.jpg"],
    },
    {
      id: 47,
      title: "Trout Lake",
      subtitle: "April 20, 2020",
      imageUrl: "/images/photos/thumbs/_MG_5454.jpg",
      largeImageUrl: ["/images/photos/_MG_5454.jpg"],
    },
    {
      id: 48,
      title: "Sgt. Pepper",
      subtitle: "January 12, 2019",
      imageUrl: "/images/photos/thumbs/_MG_6752.jpg",
      largeImageUrl: ["/images/photos/_MG_6752.jpg"],
    },
    {
      id: 49,
      title: "Duchesnay Falls",
      subtitle: "October 13, 2018",
      imageUrl: "/images/photos/thumbs/_MG_0327.jpg",
      largeImageUrl: ["/images/photos/_MG_0327.jpg"],
    },
    {
      id: 50,
      title: "Sgt. Pepper",
      subtitle: "October 28, 2018",
      imageUrl: "/images/photos/thumbs/_MG_2669f.jpg",
      largeImageUrl: ["/images/photos/_MG_2669f.jpg"],
    },
    {
      id: 51,
      title: "Chief Commanda II",
      subtitle: "August 19, 2023",
      imageUrl: "/images/photos/thumbs/_MG_6465.jpg",
      largeImageUrl: ["/images/photos/_MG_6465.jpg"],
    },
    {
      id: 52,
      title: "Raindrops",
      subtitle: "August 6, 2019",
      imageUrl: "/images/photos/thumbs/_MG_2553.jpg",
      largeImageUrl: ["/images/photos/_MG_2553.jpg"],
    },
    {
      id: 53,
      title: "King's Landing",
      subtitle: "May 28, 2023",
      imageUrl: "/images/photos/thumbs/_MG_4336.jpg",
      largeImageUrl: ["/images/photos/_MG_4336.jpg"],
    },
    {
      id: 54,
      title: "Gizmo",
      subtitle: "March 19, 2020",
      imageUrl: "/images/photos/thumbs/_MG_0646.jpg",
      largeImageUrl: ["/images/photos/_MG_0646.jpg"],
    },
    {
      id: 55,
      title: "Lake Nipissing",
      subtitle: "May 22, 2023",
      imageUrl: "/images/photos/thumbs/DJI_0310.jpg",
      largeImageUrl: ["/images/photos/DJI_0310.jpg"],
    },
    {
      id: 56,
      title: "Miles",
      subtitle: "April 14, 2023",
      imageUrl: "/images/photos/thumbs/_MG_8037c.jpg",
      largeImageUrl: ["/images/photos/_MG_8037c.jpg"],
    },
    {
      id: 57,
      title: "Partial Solar Eclipse",
      subtitle: "April 8, 2024",
      imageUrl: "/images/photos/thumbs/_MG_4885c.jpg",
      largeImageUrl: ["/images/photos/_MG_4885c.jpg"],
    },
    {
      id: 58,
      title: "Sgt. Pepper",
      subtitle: "January 28, 2023",
      imageUrl: "/images/photos/thumbs/_MG_6969.jpg",
      largeImageUrl: ["/images/photos/_MG_6969.jpg"],
    },
    {
      id: 59,
      title: "Lake Nipissing",
      subtitle: "March 11, 2025",
      imageUrl: "/images/photos/thumbs/_MG_0642.jpg",
      largeImageUrl: ["/images/photos/_MG_0642.jpg"],
    },        
    {
      id: 60,
      title: "Mischa",
      subtitle: "October 13, 2023",
      imageUrl: "/images/photos/thumbs/_MG_1385.jpg",
      largeImageUrl: ["/images/photos/_MG_1385.jpg"],
    },
    {
      id: 61,
      title: "Lake Nipissing",
      subtitle: "May 22, 2023",
      imageUrl: "/images/photos/thumbs/_MG_2204s.jpg",
      largeImageUrl: ["/images/photos/_MG_2204s.jpg"],
    },
    {
      id: 62,
      title: "Sgt. Pepper",
      subtitle: "October 13, 2023",
      imageUrl: "/images/photos/thumbs/_MG_0527.jpg",
      largeImageUrl: ["/images/photos/_MG_0527.jpg"],
    },
    {
      id: 63,
      title: "Waterfront Boardwalk",
      subtitle: "October 31, 2023",
      imageUrl: "/images/photos/thumbs/_MG_9224.jpg",
      largeImageUrl: ["/images/photos/_MG_9224.jpg"],
    },    
    {
      id: 64,
      title: "Mischa",
      subtitle: "October 13, 2023",
      imageUrl: "/images/photos/thumbs/_MG_0644.jpg",
      largeImageUrl: ["/images/photos/_MG_0644.jpg"],
    },
    {
      id: 65,
      title: "King's Landing",
      subtitle: "October 28, 2021",
      imageUrl: "/images/photos/thumbs/_MG_8351s.jpg",
      largeImageUrl: ["/images/photos/_MG_8351s.jpg"],
    },
    {
      id: 66,
      title: "Gizmo",
      subtitle: "December 31, 2020",
      imageUrl: "/images/photos/thumbs/_MG_0274.jpg",
      largeImageUrl: ["/images/photos/_MG_0274.jpg"],
    },
    {
      id: 67,
      title: "Golden Mile Beach",
      subtitle: "July 7, 2020",
      imageUrl: "/images/photos/thumbs/_MG_8795s.jpg",
      largeImageUrl: ["/images/photos/_MG_8795s.jpg"],
    },
    {
      id: 68,
      title: "Sgt. Pepper",
      subtitle: "January 12, 2019",
      imageUrl: "/images/photos/thumbs/_MG_6613c.jpg",
      largeImageUrl: ["/images/photos/_MG_6613c.jpg"],
    },
    {
      id: 69,
      title: "Lake Nipissing",
      subtitle: "January 7, 2023",
      imageUrl: "/images/photos/thumbs/_MG_2840s.jpg",
      largeImageUrl: ["/images/photos/_MG_2840s.jpg"],
    },
    {
      id: 70,
      title: "Gizmo",
      subtitle: "April 21, 2020",
      imageUrl: "/images/photos/thumbs/_MG_5751.jpg",
      largeImageUrl: ["/images/photos/_MG_5751.jpg"],
    },
    {
      id: 71,
      title: "Delaney Bay",
      subtitle: "May 28, 2017",
      imageUrl: "/images/photos/thumbs/IMG_3752s.jpg",
      largeImageUrl: ["/images/photos/IMG_3752s.jpg"],
    },
    {
      id: 72,
      title: "Sgt. Pepper",
      subtitle: "October 13, 2023",
      imageUrl: "/images/photos/thumbs/_MG_0302.jpg",
      largeImageUrl: ["/images/photos/_MG_0302.jpg"],
    },
    {
      id: 73,
      title: "Callander Bay",
      subtitle: "May 30, 2018",
      imageUrl: "/images/photos/thumbs/DJI_0143.jpg",
      largeImageUrl: ["/images/photos/DJI_0143.jpg"],
    },
    {
      id: 74,
      title: "Raindrops",
      subtitle: "August 6, 2019",
      imageUrl: "/images/photos/thumbs/_MG_2337.jpg",
      largeImageUrl: ["/images/photos/_MG_2337.jpg"],
    },
    {
      id: 75,
      title: "Lake Nipissing",
      subtitle: "May 5, 2020",
      imageUrl: "/images/photos/thumbs/_MG_0207.jpg",
      largeImageUrl: ["/images/photos/_MG_0207.jpg"],
    },
    {
      id: 76,
      title: "Mischa",
      subtitle: "October 13, 2023",
      imageUrl: "/images/photos/thumbs/_MG_0760.jpg",
      largeImageUrl: ["/images/photos/_MG_0760.jpg"],
    },
    {
      id: 77,
      title: "Delaney Bay",
      subtitle: "June 4, 2024",
      imageUrl: "/images/photos/thumbs/_MG_5101.jpg",
      largeImageUrl: ["/images/photos/_MG_5101.jpg"],
    },
    {
      id: 78,
      title: "Seagulls",
      subtitle: "April 20, 2020",
      imageUrl: "/images/photos/thumbs/_MG_5714comp.jpg",
      largeImageUrl: ["/images/photos/_MG_5714comp.jpg"],
    },
    {
      id: 79,
      title: "Lake Nipissing",
      subtitle: "January 23, 2025",
      imageUrl: "/images/photos/thumbs/DJI_20250123151513_0519_Ds.jpg",
      largeImageUrl: ["/images/photos/DJI_20250123151513_0519_Ds.jpg"],
    },
    {
      id: 80,
      title: "Sgt. Pepper",
      subtitle: "October 13, 2023",
      imageUrl: "/images/photos/thumbs/_MG_0170.jpg",
      largeImageUrl: ["/images/photos/_MG_0170.jpg"],
    },
    {
      id: 81,
      title: "Delaney Bay",
      subtitle: "October 5, 2022",
      imageUrl: "/images/photos/thumbs/_MG_9480.jpg",
      largeImageUrl: ["/images/photos/_MG_9480.jpg"],
    },
    {
      id: 88,
      title: "Joneszy",
      subtitle: "June 16, 2024",
      imageUrl: "/images/photos/thumbs/_MG_4855fs56s.jpg",
      largeImageUrl: ["/images/photos/_MG_4855fs56s.jpg"],
    },
    {
      id: 83,
      title: "Lake Nipissing",
      subtitle: "June 2, 2020",
      imageUrl: "/images/photos/thumbs/_MG_2902.jpg",
      largeImageUrl: ["/images/photos/_MG_2902.jpg"],
    },
    {
      id: 84,
      title: "Sgt. Pepper and Gizmo",
      subtitle: "December 9, 2018",
      imageUrl: "/images/photos/thumbs/_MG_4720c.jpg",
      largeImageUrl: ["/images/photos/_MG_4720c.jpg"],
    },
    {
      id: 85,
      title: "Lake Nipissing",
      subtitle: "February 16, 2021",
      imageUrl: "/images/photos/thumbs/_MG_5840sc.jpg",
      largeImageUrl: ["/images/photos/_MG_5840sc.jpg"],
    },
    {
      id: 86,
      title: "Sgt. Pepper",
      subtitle: "October 13, 2023",
      imageUrl: "/images/photos/thumbs/_MG_0485.jpg",
      largeImageUrl: ["/images/photos/_MG_0485.jpg"],
    },
    {
      id: 87,
      title: "Duchesnay Falls",
      subtitle: "October 13, 2018",
      imageUrl: "/images/photos/thumbs/_MG_0504.jpg",
      largeImageUrl: ["/images/photos/_MG_0504.jpg"],
    },
    {
      id: 90,
      title: "Gizmo",
      subtitle: "March 27, 2020",
      imageUrl: "/images/photos/thumbs/_MG_1222.jpg",
      largeImageUrl: ["/images/photos/_MG_1222.jpg"],
    },
    {
      id: 89,
      title: "The Motherhouse",
      subtitle: "September 28, 2023",
      imageUrl: "/images/photos/thumbs/DJI_0261.jpg",
      largeImageUrl: ["/images/photos/DJI_0261.jpg"],
    },
    {
      id: 82,
      title: "Gizmo and Sgt. Pepper",
      subtitle: "October 22, 2018",
      imageUrl: "/images/photos/thumbs/_MG_1787c.jpg",
      largeImageUrl: ["/images/photos/_MG_1787c.jpg"],
    },
    

  ],
  experience: {
    workingExperience: [
      {
        id: 1,
        year: "2011 - Present",
        position: "Marketing Web Developer",
        company: "Nipissing University",
        details:
          "",
      },
      {
        id: 2,
        year: "2010 - 2011",
        position: "First Generation Photojournalism Project Leader",
        company: "Nipissing University",
        details:
          "",
      },
      {
        id: 3,
        year: "2010",
        position: "Communications Technician",
        company: "Ministry of Northern Development, Mines and Forestry",
        details:
          "",
      },
      {
        id: 4,
        year: "2009",
        position: "Infrastructure Technology Support Technologist",
        company: "Ministry of Government and Consumer Services",
        details:
          "",
      },
      {
        id: 5,
        year: "2007 - 2008",
        position: "Park Ranger",
        company: "Ministry of Northern Development, Mines and Forestry",
        details:
          "",
      },
    ],
    educationExperience: [
      {
        id: 1,
        year: "2025",
        graduation: "Certificate in Back-End Development",
        university: "University of Waterloo",
        details:
          "",
      },
      {
        id: 2,
        year: "2024",
        graduation: "Certificate in Cloud Computing and Security",
        university: "University of Waterloo",
        details:
          "",
      },
      {
        id: 3,
        year: "2023",
        graduation: "Certificate in Digital Communications",
        university: "Cambrian College of Applied Arts and Technology",
        details:
          "",
      },
      {
        id: 4,
        year: "2020",
        graduation: "Certificate in Advanced Digital Analytics for Higher Ed",
        university: "Higher Ed Experts",
        details:
          "",
      },
      {
        id: 5,
        year: "2014",
        graduation: "Certificate in Web Analytics for Higher Ed",
        university: "Higher Ed Experts",
        details:
          "",
      },
      {
        id: 6,
        year: "2010",
        graduation: "Certificate in Advertising",
        university: "Cambrian College of Applied Arts and Technology",
        details:
          "",
      },
      {
        id: 7,
        year: "2010",
        graduation: "Diploma in General Arts and Science",
        university: "Cambrian College of Applied Arts and Technology",
        details:
          "",
      },
      {
        id: 8,
        year: "2009",
        graduation: "Diploma in Computer Programming",
        university: "Cambrian College of Applied Arts and Technology",
        details:
          "",
      },
    ]
  },
  blogs: [
    {
      id: 1,
      title: "Markdown & Html supported blog.",
      featuredImage: "/images/blog-image-1.jpg",
      filesource: "../../blog/markdown-html-supported-blog.md",
      createDay: "20",
      createMonth: "February",
      createYear: "2020",
    },
    {
      id: 2,
      title: "Installing NodeJS on your device.",
      featuredImage: "/images/blog-image-2.jpg",
      filesource: "../../blog/installing-nodejs-on-your-device.md",
      createDay: "20",
      createMonth: "February",
      createYear: "2020",
    },
    {
      id: 3,
      title: "UI/UX design starter with Adobe XD.",
      featuredImage: "/images/blog-image-3.jpg",
      filesource: "../../blog/uiux-design-starter-with-adobe-xd.md",
      createDay: "20",
      createMonth: "February",
      createYear: "2020",
    },
    {
      id: 4,
      title: "Boost your post for increasing sales.",
      featuredImage: "/images/blog-image-4.jpg",
      filesource: "../../blog/boost-your-post-for-increasing-sales.md",
      createDay: "20",
      createMonth: "February",
      createYear: "2020",
    },
    {
      id: 5,
      title: "Difference between GatsbyJS & NextJS.",
      featuredImage: "/images/blog-image-5.jpg",
      filesource: "../../blog/difference-between-gatsbyjs-and-nextjs.md",
      createDay: "20",
      createMonth: "February",
      createYear: "2020",
    },
    {
      id: 6,
      title: "How to choose javascript framework for project.",
      featuredImage: "/images/blog-image-6.jpg",
      filesource:
        "../../blog/how-to-choose-javascript-framework-for-project.md",
      createDay: "20",
      createMonth: "February",
      createYear: "2020",
    },
    {
      id: 7,
      title: "Web automation with python language.",
      featuredImage: "/images/blog-image-7.jpg",
      filesource: "../../blog/web-automation-with-python-language.md",
      createDay: "20",
      createMonth: "February",
      createYear: "2020",
    },
    {
      id: 8,
      title: "Time to use latest technology for creating a website.",
      featuredImage: "/images/blog-image-8.jpg",
      filesource:
        "../../blog/time-to-use-latest-technology-for-creating-a-website.md",
      createDay: "20",
      createMonth: "February",
      createYear: "2020",
    },
    {
      id: 9,
      title: "Think out of the box.",
      featuredImage: "/images/blog-image-9.jpg",
      filesource: "../../blog/think-out-of-the-box.md",
      createDay: "20",
      createMonth: "February",
      createYear: "2020",
    },
    {
      id: 10,
      title: "Trending designs in 2020.",
      featuredImage: "/images/blog-image-1.jpg",
      filesource: "../../blog/trending-designs-in-2020.md",
      createDay: "20",
      createMonth: "February",
      createYear: "2020",
    },
    {
      id: 11,
      title: "How to get 10k instagram followers?",
      featuredImage: "/images/blog-image-2.jpg",
      filesource: "../../blog/how-to-get-10k-instagram-followers.md",
      createDay: "20",
      createMonth: "February",
      createYear: "2020",
    },
    {
      id: 12,
      title: "What NodeJS can do?",
      featuredImage: "/images/blog-image-3.jpg",
      filesource: "../../blog/what-nodejs-can-do.md",
      createDay: "20",
      createMonth: "February",
      createYear: "2020",
    },
    {
      id: 13,
      title: "Futures of javascript.",
      featuredImage: "/images/blog-image-4.jpg",
      filesource: "../../blog/future-of-javascript.md",
      createDay: "20",
      createMonth: "February",
      createYear: "2020",
    },
    {
      id: 14,
      title: "Popular javascript library in 2020.",
      featuredImage: "/images/blog-image-5.jpg",
      filesource: "../../blog/popular-javascript-library-in-2020.md",
      createDay: "20",
      createMonth: "February",
      createYear: "2020",
    },
    {
      id: 15,
      title: "Promrammers must read books.",
      featuredImage: "/images/blog-image-6.jpg",
      filesource: "../../blog/programmers-must-read-books.md",
      createDay: "20",
      createMonth: "February",
      createYear: "2020",
    },
  ],
  contactInfo: {
    phoneNumbers: ["+ 705.493.9495"],
    emailAddress: ["paul@paulritter.ca"],
    address: "North Bay, Ontario, Canada",
    socialProfiles: "My Social Profiles",
  },
};

Mock.onGet("/api/information").reply((config) => {
  const response = database.information;
  return [200, response];
});

Mock.onGet("/api/services").reply((config) => {
  const response = database.services;
  return [200, response];
});

Mock.onGet("/api/reviews").reply((config) => {
  const response = database.reviews;
  return [200, response];
});

Mock.onGet("/api/skills").reply((config) => {
  const response = database.skills;
  return [200, response];
});

Mock.onGet("/api/portfolios").reply((config) => {
  const response = database.portfolios;
  return [200, response];
});

Mock.onGet("/api/experience").reply((config) => {
  const response = database.experience;
  return [200, response];
});

Mock.onGet("/api/blog").reply((config) => {
  const response = database.blogs;
  return [200, response];
});

Mock.onGet("/api/contactinfo").reply((config) => {
  const response = database.contactInfo;
  return [200, response];
});
